import { action, withPayload } from '../../../utility/redux';

export const setNeedCloseModal = action(
  'SET_NEED_CLOSE_MODAL',
  withPayload<boolean>(),
);
